import React, {MutableRefObject, useEffect, useMemo, useRef} from "react";
import {Group, Plane, Raycaster, Vector2, Vector3} from "three";
import {useThree} from "@react-three/fiber";

import {TextMarker} from "./TextMarker";
import {formatCoordinate} from "../formatCoorindate";

/**
 * Given the min and max position, and the current position on a certain dimension,
 * translate the position such that -1 corresponds with the minimum position
 * and 1 with the maximum position
 */
export function translateMousePos(position: number, min: number, max: number) {
  return (position - min) / (max - min) * 2 - 1;
}

/**
 * Shows a text marker at the point where the cursor (from the perspective
 * 'raycaster' solve of the camera) meets the ground plane in the scene
 */
export const CursorCoordinatePlane: React.FC<{
  gridRadius: number;
  getViewerBounds?: () => (DOMRect | undefined);
}> = ({gridRadius, getViewerBounds}) => {

  const camera     = useThree().camera;
  const raycaster  = useRef() as MutableRefObject<Raycaster>;
  const textMarker = useRef() as MutableRefObject<Group>;
  const innerText  = useRef() as MutableRefObject<{ text: string }>;

  const plane = useMemo(() => {
    return new Plane(new Vector3(0, 1, 0), 0);
  }, []);

  const mouseVector2 = useMemo(() => {
    return new Vector2();
  }, []);

  useEffect(() => {
    const eventListener = (e: MouseEvent) => {
      // from https://jsfiddle.net/amitlzkpa/c53w8erf/
      const viewerBounds = getViewerBounds?.();
      mouseVector2.x     = translateMousePos(e.clientX, viewerBounds?.x ?? 0, viewerBounds?.right ?? window.innerWidth);
      mouseVector2.y     = -translateMousePos(e.clientY, viewerBounds?.y ?? 0, viewerBounds?.bottom ?? window.innerHeight);
      raycaster.current.setFromCamera(mouseVector2, camera);
      const intersection = raycaster.current.ray.intersectPlane(plane, new Vector3());
      if (intersection) {
        const x                       = intersection.x;
        const z                       = intersection.z;
        textMarker.current.position.x = x;
        textMarker.current.position.z = z;
        innerText.current.text        = `${formatCoordinate(x * gridRadius)} , ${formatCoordinate(z * gridRadius)}`;
      }
    };
    window.addEventListener('mousemove', eventListener);
    return () => window.removeEventListener('mousemove', eventListener);
  }, [camera, gridRadius, getViewerBounds, mouseVector2, plane]);

  return <>
    <raycaster ref={raycaster}/>
    <TextMarker
      ref={textMarker}
      innerTextRef={innerText}
      text={'hoi'}
      position={[0, 0, 0]}
    />
  </>;
};